(function () {
  'use strict';

  if (window.BKV29Media) {
    window.BKV29Media.scan();
    return;
  }

  const observed = new Set();
  const visible = new WeakSet();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function hydrate(video) {
    if (video.dataset.bkHydrated === 'true') return;
    let hasSource = false;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      if (!source.src) source.src = source.dataset.src;
      hasSource = true;
    });
    if (!video.src && video.dataset.src) {
      video.src = video.dataset.src;
      hasSource = true;
    }
    if (video.dataset.poster && !video.poster) video.poster = video.dataset.poster;
    if (video.dataset.bkPreviewFrame === 'true') {
      video.preload = 'metadata';
      video.addEventListener('loadedmetadata', () => {
        const target = Number.isFinite(video.duration) && video.duration > 2
          ? Math.min(1.5, Math.max(0.6, video.duration * 0.08))
          : 0.8;
        try { video.currentTime = target; } catch (error) {}
      }, { once: true });
      video.addEventListener('seeked', () => {
        video.pause();
        video.dataset.bkPreviewReady = 'true';
      }, { once: true });
    }
    if (hasSource) video.load();
    video.dataset.bkHydrated = 'true';
  }

  function playIfAllowed(video) {
    if (video.dataset.autoplay !== 'true' || reduceMotion.matches || document.hidden) return;
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.play().catch(() => {});
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting) {
        visible.add(video);
        hydrate(video);
        playIfAllowed(video);
      } else {
        visible.delete(video);
        video.pause();
      }
    });
  }, { rootMargin: '320px 0px', threshold: 0.01 });

  function scan(scope = document) {
    const videos = scope.matches?.('video[data-bk-lazy-video]')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('video[data-bk-lazy-video]') || []);
    videos.forEach((video) => {
      if (observed.has(video)) return;
      observed.add(video);
      observer.observe(video);
    });
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      document.querySelectorAll('video[data-bk-lazy-video]').forEach((video) => video.pause());
    } else {
      document.querySelectorAll('video[data-bk-lazy-video][data-autoplay="true"]').forEach((video) => {
        if (visible.has(video)) playIfAllowed(video);
      });
    }
  });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const videos = event.target.matches?.('video[data-bk-lazy-video]')
      ? [event.target]
      : Array.from(event.target.querySelectorAll?.('video[data-bk-lazy-video]') || []);
    videos.forEach((video) => {
      observer.unobserve(video);
      observed.delete(video);
      visible.delete(video);
      video.pause();
    });
  });

  window.BKV29Media = { hydrate, scan };
  scan();
})();
